import { render, staticRenderFns } from "./BaseData.vue?vue&type=template&id=65da3967"
import script from "./BaseData.js?vue&type=script&lang=js&external"
export * from "./BaseData.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports